import { render, staticRenderFns } from "./ContactEditForm.vue?vue&type=template&id=18353a3f&"
import script from "./ContactEditForm.vue?vue&type=script&lang=js&"
export * from "./ContactEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports